import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { User } from '../../shared/interfaces/CreateOrUpdateUserPayload';
import { environment } from '../../../environments/environment';
import { Metadata, Page, Roles } from '@gbr-monorepo/interfaces';

@Injectable({
    providedIn: 'root'
})
export class UserManagementService {
    private httpClient = inject(HttpClient);

    private apiUrl = `${environment.apiUrl}/v1/users`;

    public getUsers(
        page: number,
        pageSize: number,
        searchTerm: string
    ): Observable<{ items: User[]; metadata: Metadata }> {
        const params = {
            page,
            pageSize,
            orderBy: 'last_name',
            sortOrder: 'ASC'
        };
        if (searchTerm?.length) {
            params['searchTerm'] = searchTerm;
        }
        return this.httpClient.get<{ items: User[]; metadata: Metadata }>(`${this.apiUrl}`, {
            params
        });
    }

    public getDelegateUsers(search: string, page: number): Observable<Page<User>> {
        const params = { page, roles: [Roles.DELEGATE] };

        if (search) {
            params['searchTerm'] = search;
        }

        return this.httpClient.get<Page<User>>(`${this.apiUrl}`, { params });
    }

    public createUser(user: User): Observable<User> {
        return this.httpClient.post<User>(`${this.apiUrl}`, user);
    }

    public updateUser<T extends Partial<User>>(user: T & { gid: string }): Observable<User> {
        const { gid, ...rest } = user;
        return this.httpClient.patch<User>(`${this.apiUrl}/${gid}`, rest);
    }

    public deleteUser(gid: string): Observable<User> {
        return this.httpClient.delete<User>(`${this.apiUrl}/${gid}`);
    }

    public getUser(gid: string): Observable<User> {
        return this.httpClient.get<User>(`${this.apiUrl}/${gid}`);
    }
}
